import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Radio } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StudioQuickLauncher() {
  const location = useLocation();
  const navigate = useNavigate();
  const [allowed, setAllowed] = useState(false);
  const match = location.pathname.match(/^\/communications\/rooms\/([^/]+)$/);
  const roomId = match?.[1] || null;
  const target = roomId ? `/communications/studio/${roomId}${location.hash || ""}` : null;

  useEffect(() => {
    let active = true;
    if (!roomId) {
      setAllowed(false);
      return () => { active = false; };
    }
    axios.get(`${API}/communications/rooms/${roomId}`)
      .then((response) => { if (active) setAllowed(Boolean(response.data?.is_host)); })
      .catch(() => { if (active) setAllowed(false); });
    return () => { active = false; };
  }, [roomId]);

  useEffect(() => {
    if (!allowed || !target) return undefined;
    const handler = (event) => {
      const button = event.target?.closest?.("button");
      if (!button) return;
      if (button.textContent?.trim() !== "Open Studio") return;
      event.preventDefault();
      event.stopPropagation();
      navigate(target);
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [allowed, navigate, target]);

  if (!allowed || !target) return null;

  return (
    <Link
      to={target}
      className="fixed bottom-6 left-6 z-[65] inline-flex items-center gap-2 rounded-full bg-kingdom-gold px-5 py-3 font-bold text-royal-blue shadow-xl hover:scale-[1.02] transition-transform"
      data-testid="studio-quick-launcher"
    >
      <Radio className="w-5 h-5" /> Open Studio
    </Link>
  );
}
